import React from 'react'

export default () => {
  const [user, setUser] = React.useState(null)

  React.useEffect(() => {
    if (user && user.username) return

    try {
      const u = JSON.parse(
        atob(
          localStorage.getItem('fetch_auth_token-admissions-data').split('.')[1]
        )
      )
      setUser(u)
    } catch (e) {
      setTimeout(() => setUser(new Date()), 1000)
    }
  }, [user])

  const logout = React.useCallback(() => {
    window.localStorage.clear()
    window.location = 'http://oiraweb.ua.edu/api/auth/logout'
  }, [])

  return user && user.username ? (
    <div style={{ color: '#333', paddingRight: '1em', marginTop: '-1.25em' }}>
      Logged in: {user.username} |{' '}
      <button className="logout" title="You don't have to go!" onClick={logout}>
        logout
      </button>
    </div>
  ) : (
    <div />
  )
}
